import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { FullPageModal, FullPageModalHeaderActions } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import styles from './BillModalShell.module.scss';
export const GetBillModalShellTID = (parentTestId)=>getTestIds(parentTestId);
export const BillModalShell = (param)=>{
    let { title, mainAction, secondaryAction, additionalActions, onClose, children, testId } = param;
    const { BillModalShellTestIds } = useMemo(()=>GetBillModalShellTID(testId), [
        testId
    ]);
    return /*#__PURE__*/ _jsxs(FullPageModal, {
        className: styles.root,
        testId: BillModalShellTestIds.Root(),
        onClose: onClose,
        children: [
            /*#__PURE__*/ _jsx(FullPageModal.HeaderStart, {
                children: title
            }),
            /*#__PURE__*/ _jsx(FullPageModalHeaderActions, {
                testId: testId,
                mainAction: mainAction,
                secondaryAction: secondaryAction,
                additionalActions: additionalActions
            }),
            children
        ]
    });
};
